// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.czt-link.czt-link{text-decoration:none;color:#178fcf}a.czt-link.czt-link:hover{text-decoration:underline}a.czt-link.czt-link--light{color:#fff;text-decoration:underline}a.czt-link.czt-link--light:hover{color:#ff0018;text-decoration:none}", ""]);
// Exports
module.exports = exports;
